import { render } from "./EmployeeModal.vue?vue&type=template&id=52b9cfb2&scoped=true"
import script from "./EmployeeModal.vue?vue&type=script&lang=js"
export * from "./EmployeeModal.vue?vue&type=script&lang=js"

import "./EmployeeModal.vue?vue&type=style&index=0&id=52b9cfb2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52b9cfb2"]])

export default __exports__